
const { TARGET, LIBRARY_TARGET } = require('./constant');

// 常用的OPTIONS
const OPTIONS = {
    // 支持目标文档
    target: ({ Option }) => new Option('-t, --target [string]', 'server target module').choices(TARGET),
    // debug: new Option('-d, --debug', 'is show debug log').default(false, 'toggle show debug log'),
    debug: ({ Option }) => new Option('-d, --debug', 'show debug log'),
    // 默认的输出类型
    libraryTarget: ({ Option }) => new Option('-t, --libraryTarget [string]', 'output libraryTarget').choices(LIBRARY_TARGET).default(LIBRARY_TARGET[0], 'default is umd'),
    // message 用户输入信息
    message: ({ Option }) => new Option('-msg, --message [string]', 'git submit or change log message'),
}

module.exports = OPTIONS;